window.Axis80Modal = (function () {
  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        [
          'a[href]',
          'button:not([disabled])',
          'textarea:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',')
      )
    ).filter((el) => el.offsetParent !== null);
  }

  function open(title, content, opener) {
    if (!content) return;

    const existingModal = document.querySelector('[data-axis80-modal]');
    if (existingModal) existingModal.remove();

    const modal = document.createElement('div');
    modal.className = 'axis80-modal';
    modal.setAttribute('data-axis80-modal', '');

    modal.innerHTML = `
      <div class="axis80-modal__overlay" data-axis80-modal-close></div>

      <div
        class="axis80-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="axis80-modal-title"
        aria-describedby="axis80-modal-content"
        tabindex="-1"
      >
        <div class="axis80-modal__header">
          <h2 id="axis80-modal-title">${title}</h2>

          <button
            type="button"
            class="axis80-modal__close"
            aria-label="Close dialog"
            data-axis80-modal-close
          >
            ×
          </button>
        </div>

        <div class="axis80-modal__content" id="axis80-modal-content">
          ${content}
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    document.body.classList.add('axis80-modal-is-open');

    const dialog = modal.querySelector('.axis80-modal__dialog');
    const closeButtons = modal.querySelectorAll('[data-axis80-modal-close]');

    function close() {
      document.body.classList.remove('axis80-modal-is-open');
      modal.remove();
      document.removeEventListener('keydown', handleKeydown);

      if (opener && typeof opener.focus === 'function') {
        opener.focus();
      }
    }

    function trapFocus(event) {
      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements(dialog);

      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }

      trapFocus(event);
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', handleKeydown);
    dialog.focus();
  }

  return {
    open
  };
})();